export default __webpack_public_path__ + "static/media/btn-spotify.60bf2fc5.webp";